import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Popup from './Popup';
import Input from './Input';
import { useRef } from 'react';

const Container = styled.div`
    width: ${props => props.width};
    height: ${props => props.height};
    background-image: linear-gradient(#fff, #bbb);
    cursor: pointer;
    color: white;

    @media (max-width: 1000px) {
        width: ${props => props.shouldShrinkOnMobile ? "300px" : props.width};
        height: ${props => props.shouldShrinkOnMobile ? "300px" : props.height};
    }

    div {
        padding: 40px;
        display: flex;
        justify-content: center;
        align-items: end;
        height: 100%;
        background-image: url('/img/croix_blanche.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 30px;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        max-height: 100%;
        margin: 0;
    }
`;

const ImageUpload = (props) => {

    const [currentImage, setCurrentImage] = useState(props.currentImagePath || '');
    const [credit, setCredit] = useState(props.creditFieldDefaultValue || '');
    const [popupOpen, setPopupOpen] = useState(false); 
    const fileInputRef = useRef(null);

    if(props.creditFieldDefaultValue && !credit) {
        setCredit(props.creditFieldDefaultValue);
    }

    const { i18n } = useTranslation('common');

    const handleImageEdit = () => {
        setPopupOpen(true);
    };

    const handleInputChange = (event) => {
        setCurrentImage(URL.createObjectURL(event.target.files[0]));
    };

    const handleAddImage = (event) => {
        event.preventDefault();
        if (fileInputRef.current) {
            fileInputRef.current.click(); // Trigger the file selection popup
        }
    };

    const changeCreditInput = (event) => {
        setCredit(event.target.value);
    };

    React.useEffect(() => {
        setCurrentImage(props.currentImagePath);
    }, [props.currentImagePath]);

    let shouldShrinkOnMobile = false;
    if(props.width === "400px" && props.height === "400px") {
        shouldShrinkOnMobile = true;
    }

    return (
        <div>
            <Container width={props.width} height={props.height} shouldShrinkOnMobile={shouldShrinkOnMobile}>
                {currentImage ? (
                    <img src={currentImage} alt='' onClick={handleImageEdit} />
                ) : (
                    <>
                        <div onClick={handleImageEdit}><span>{i18n.language === 'fr' ? ("Ajouter " + props.textFR) : ("Add " + props.textEN)}{props.required && "*"}</span></div>
                    </>
                )}
            </Container>
            <input hidden name={props.name} type='file' accept="image/png, image/jpeg" onChange={handleInputChange} ref={fileInputRef}/>
            <input hidden readOnly name={props.creditFieldName} value={credit}/>
            {popupOpen &&
                <Popup close={() => setPopupOpen(false)}>
                    {currentImage ? (
                        <>
                            <span>{i18n.language === 'fr' ? ("Image sélectionnée :") : ("Selected image:")}</span>
                            <img src={currentImage} alt='' onClick={handleImageEdit} />
                            <button onClick={event => handleAddImage(event)}>{i18n.language === 'fr' ? 'Sélectionner une autre image' : 'Select another image'}</button><br/>
                        </>
                    ) : (
                        <>
                            <span>{i18n.language === 'fr' ? ("Pas d'image sélectionnée.") : ("No image selected.")}</span><br/>
                            <button onClick={event => handleAddImage(event)}>{i18n.language === 'fr' ? 'Sélectionner une image' : 'Select an image'}</button><br/>
                        </>      
                    )}
                    <span className='thin'>{i18n.language === "fr" ? "(.png, .jpg ou .jpeg, 50Mo maximum)" : "(.png, .jpg or .jpeg, 50Mb maximum)"}</span><br/>
                    <Input style={{width:"100%"}} required onChange={changeCreditInput} placeholder={i18n.language === "fr" ? "Crédit de l'image" : "Image copyright"} defaultValue={credit} /><br/>
                    <button onClick={(event) => {event.preventDefault(); setPopupOpen(false)}}>{i18n.language === 'fr' ? 'Valider' : 'Validate'}</button>
                </Popup>
            }
        </div>
    );
};

export default ImageUpload;
